module.exports = __webpack_public_path__ + "static/media/jug5qt.c7bb9330.svg";